"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFilterItemsState = setFilterItemsState;
exports.ShowResult = ShowResult;
const PREFIX = "t-and-c-acceptance-status/";
function setFilterItemsState(filterItemsState) {
    return {
        type: `${PREFIX}SET_FILTER_ITEMS_STATE`,
        filterItemsState
    };
}
function ShowResult() {
    return {
        type: `${PREFIX}SHOW_RESULT`
    };
}
//# sourceMappingURL=actions.js.map